import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdLayers } from 'react-icons/md';
import * as Styled from './styles';
import iconsThemes from './iconsThemes';
import linksEstatisticaMineral from './linksEstatisticaMineral';
import { ICategory, ISubTheme, ITheme } from 'contexts/@types/Layers';
import { useLayers } from 'hooks/useLayers';
import empreendedor from 'assets/icone/busca/empreendedor.png';
import empreendimento from 'assets/icone/busca/empreendimento.png';
import documentos from 'assets/icone/busca/documentos.png';
import { useMap } from 'hooks/useMap';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import * as RiIcons from 'react-icons/ri';

interface IHomeSideBar {
  handleChangeTabIndex: (index: number, text: string, icon: React.ReactNode, subBreadcrumbs?: string[]) => void;
}

export function Home({ handleChangeTabIndex }: IHomeSideBar) {
  const { categoryList, handleOpenCategory, handleOpenTheme, setSubThemeGraph, handleAddLayer } = useLayers();
  const { handleAddOverlayLayer } = useMap();
  const {} = useLayers();
  const { t: translation } = useTranslation();

  return (
    <Styled.Wrapper>
      <Styled.ContainerColor color="#e5e7ebab">
        <h1>{translation('mapPage.sideBar.home.themes.titleCommodities')}</h1>
        <Styled.ThemeGrid>
          {categoryList.at(0) &&
            categoryList.at(0)?.temas.map((theme: ITheme, indexTheme: number) => {
              if (!theme.visivel) return;

              const iconTheme = iconsThemes.find(t => t.id === theme.id_tema);
              return (
                <Styled.Button key={'commodities_themes_' + indexTheme} color={iconTheme?.color}>
                  <Styled.Header
                    color={iconTheme?.color}
                    open={theme.opened}
                    onClick={() => {
                      handleOpenTheme(!theme.opened, 0, indexTheme);
                    }}
                  >
                    <Styled.Icone className="icone" path={iconTheme?.image} color={iconTheme?.color}></Styled.Icone>
                    <p>
                      {theme.opened && <Styled.IconeColor path={iconTheme?.imageColor}></Styled.IconeColor>}
                      {theme.nm_tema}
                    </p>
                  </Styled.Header>

                  {theme.opened && (
                    <Styled.Tematicas color={iconTheme?.color} className="tematicas">
                      {theme.subtema?.length &&
                        theme.subtema.map((subTheme: ISubTheme, indexSubTheme: number) => {
                          if (!subTheme.visivel) return;

                          return (
                            <Styled.Tematica
                              color={'commodities_sub_themes_' + iconTheme?.color}
                              key={indexSubTheme}
                              onClick={() => {
                                setSubThemeGraph(subTheme);
                                subTheme.layers?.forEach(layer => {
                                  handleAddLayer(layer);
                                  handleAddOverlayLayer(layer);
                                });

                                handleChangeTabIndex(
                                  3,
                                  translation('mapPage.sideBar.navigationBottomBar.charts'),
                                  <RiIcons.RiBarChart2Fill />,
                                );
                              }}
                            >
                              <a>{subTheme.nm_subtema}</a>
                            </Styled.Tematica>
                          );
                        })}
                    </Styled.Tematicas>
                  )}
                </Styled.Button>
              );
            })}
        </Styled.ThemeGrid>
      </Styled.ContainerColor>

      <Styled.ContainerColor color="#FFFFFF">
        <h1 className="titulo">{translation('mapPage.sideBar.home.themes.titleTema')}</h1>
        <Styled.ExplorarMapa>
          {categoryList.map((category: ICategory, indexCategory: number) => {
            if (category.id_categoria === 1 || category.id_categoria === 6) return;

            return (
              <Styled.ButtonFlex
                key={'category_' + indexCategory}
                onClick={() => {
                  handleOpenCategory(!category.opened, indexCategory);
                  handleChangeTabIndex(2, translation('mapPage.sideBar.navigationBottomBar.layers'), <MdLayers />);
                }}
              >
                <Styled.Header>
                  <p>{category.nm_categoria}</p>
                </Styled.Header>
              </Styled.ButtonFlex>
            );
          })}
        </Styled.ExplorarMapa>
      </Styled.ContainerColor>

      <Styled.ContainerColor color="#e5e7ebab">
        <h1 className="titulo">{translation('mapPage.sideBar.home.themes.titleBusca')}</h1>
        <Styled.BuscaRapida>
          <Styled.Busca>
            <Styled.IconeBusca className="icone-busca" path={empreendedor}></Styled.IconeBusca>
            <p>Titular de Empreendimento</p>
            <Styled.ButtonBusca disabled data-tip data-for="functionalDev">
              Iniciar busca
            </Styled.ButtonBusca>
          </Styled.Busca>

          <Styled.Busca>
            <Styled.IconeBusca className="icone-busca" path={empreendimento}></Styled.IconeBusca>
            <p>Empreendimento</p>
            <Styled.ButtonBusca disabled data-tip data-for="functionalDev">
              Iniciar busca
            </Styled.ButtonBusca>
          </Styled.Busca>

          <Styled.Busca>
            <Styled.IconeBusca className="icone-busca" path={documentos}></Styled.IconeBusca>
            <p>Documentos e Relatórios</p>
            <Styled.ButtonBusca disabled data-tip data-for="functionalDev">
              Iniciar busca
            </Styled.ButtonBusca>
          </Styled.Busca>
        </Styled.BuscaRapida>
      </Styled.ContainerColor>

      <Styled.ContainerColor color="#FFFFFF">
        <h1 className="titulo">{translation('mapPage.sideBar.home.themes.titleEstatistica')}</h1>
        <Styled.Estatistica>
          {linksEstatisticaMineral.map((item) => {
            return (
              <Styled.ContentEconomiaMineral key={item.id}>
                <h1>{item.title}</h1>
                <div>
                  {item.links.map(linkItem => {
                    const openInNewWindow = linkItem.link.startsWith('https://');

                    return (
                      <Styled.Button key={'links_' + linkItem.id}>
                        <Styled.Header className="default">
                          {openInNewWindow ? (
                            <a href={linkItem.link} target="_blank" rel="noreferrer">
                              {linkItem.nome}
                            </a>
                          ) : (
                            <Link to={linkItem.link}>{linkItem.nome}</Link>
                          )}
                        </Styled.Header>
                      </Styled.Button>
                    );
                  })}
                </div>
              </Styled.ContentEconomiaMineral>
            );
          })}
        </Styled.Estatistica>
      </Styled.ContainerColor>

      <ReactTooltip id="functionalDev" place="top" type="warning" effect="solid" delayShow={500} delayHide={500}>
        <p>{translation('mapPage.sideBar.navigationRightBar.functionalDev')}</p>
      </ReactTooltip>
    </Styled.Wrapper>
  );
}
